import { LoyaltyProvider } from "../../types/enums";
import { LoyaltyService } from "../loyalty-service";
import { ILoyaltyProvider } from "./loyalty-provider.interface";
import { AdoraProvider } from "./adora-provider";
import { NoneProvider } from "./none-provider";
import { PunchhProvider } from "./punchh-provider";
import { Data } from "../../models/data";
import { Order } from "../../models/order";
import { User } from "../../models/user";
import { Context } from "../../models/context";
import { LocalizationService } from "../localization-service";
import { DataLayerService } from "../data-layer-service";

export class LoyaltyProviderFactory {
    static getLoyaltyProvider(data: Data, context: Context, localizationService: LocalizationService, user: User, order: Order, loyaltyService: LoyaltyService, dataLayerService: DataLayerService, loyaltyProviderId: LoyaltyProvider): ILoyaltyProvider {
        switch (loyaltyProviderId) {
            case LoyaltyProvider.ADORA:
                return new AdoraProvider(data, context, localizationService, user, order, loyaltyService, dataLayerService);
            case LoyaltyProvider.PUNCHH:
                return new PunchhProvider(data, context, localizationService, user, order, loyaltyService, dataLayerService);
            default:
                return new NoneProvider(data, context, localizationService, order, user, loyaltyService, dataLayerService);
        }
    }
}